(function() {
  function getVariants(sectionElement) {
    const tmpl = sectionElement.querySelector('xo-product-data template');
    if (!tmpl) return [];
    try {
      const data = JSON.parse(tmpl.content.querySelector('script').textContent);
      return data.variants || [];
    } catch(e) { return []; }
  }

  function switchToMedia(sectionElement, targetFilename) {
    const galleryComponent = sectionElement.querySelector('xo-gallery');
    if (!galleryComponent) return;

    let targetIndex = -1;
    const galleryItems = galleryComponent.querySelectorAll('xo-gallery-item');
    galleryItems.forEach(item => {
      const itemSrc = item.getAttribute('xo-src');
      if (itemSrc && itemSrc.includes(targetFilename)) {
        const idx = parseInt(item.getAttribute('xo-index'), 10);
        if (!isNaN(idx)) targetIndex = idx;
      }
    });

    if (targetIndex === -1) return;

    const mainCarousel = galleryComponent.querySelector('xo-carousel');
    if (!mainCarousel) return;

    const mainSlides = mainCarousel.querySelectorAll('xo-carousel-slide');
    const mainList = mainCarousel.querySelector('xo-carousel-list');

    if (mainList && mainSlides[targetIndex]) {
      mainList.style.transform = `translate3d(-${mainSlides[targetIndex].offsetLeft}px, 0px, 0px)`;
      mainSlides.forEach(s => s.removeAttribute('xo-active'));
      mainSlides[targetIndex].setAttribute('xo-active', '');
    }

    const thumbContainer = galleryComponent.querySelector('xo-carousel-thumbnail');
    if (!thumbContainer) return;

    const thumbSlides = thumbContainer.querySelectorAll('xo-carousel-slide');
    const thumbList = thumbContainer.querySelector('xo-carousel-list');

    if (thumbList && thumbSlides[targetIndex]) {
      thumbList.style.transform = `translate3d(-${thumbSlides[targetIndex].offsetLeft}px, 0px, 0px)`;
      thumbSlides.forEach(s => s.removeAttribute('xo-active'));
      thumbSlides[targetIndex].setAttribute('xo-active', '');
    }
  }

  function initializeBundleSelectors() {
    const containers = document.querySelectorAll('.package-selector-container');
    containers.forEach(container => {
      if (container.dataset.bundleInitialized) return;

      const radioButtons = container.querySelectorAll('.package-selector__radio-input');
      const section = container.closest('.shopify-section');
      const sectionId = section ? section.id.replace('shopify-section-', '') : null;

      const updateIncludesVisibility = () => {
        const allGroups = container.querySelectorAll('.package-selector__variant-group');
        allGroups.forEach(group => {
          const radio = group.querySelector('.package-selector__radio-input');
          const includesContainer = group.querySelector('.package-includes-container');
          if (!includesContainer) return;
          const hasContent = includesContainer.innerText.trim() !== '';
          if (radio && radio.checked && hasContent) {
            includesContainer.style.display = 'block';
          } else {
            includesContainer.style.display = 'none';
          }
        });
      };

      const updateMainForm = (variantId, switchMedia = true) => {
        if (!sectionId) return;

        const sectionElement = document.getElementById(`shopify-section-${sectionId}`);
        if (!sectionElement) return;

        const mainProductForm = sectionElement.querySelector('form[id^="product_form_id-"], form[id^="product-form-"]');
        if (mainProductForm) {
          const input = mainProductForm.querySelector('input[name="id"]');
          if (input) {
            input.value = variantId;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        if (switchMedia) {
          const variants = getVariants(sectionElement);
          const selectedVariant = variants.find(v => v.id == variantId);
          if (selectedVariant && selectedVariant.featured_image) {
            const filename = selectedVariant.featured_image.src.split('/').pop().split('?')[0];
            switchToMedia(sectionElement, filename);
          }
        }

        document.body.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: { id: variantId } } }));
        document.body.dispatchEvent(new CustomEvent('custom:price:update', { bubbles: true, detail: { variantId: variantId } }));
      };

      radioButtons.forEach(radio => {
        radio.addEventListener('change', (event) => {
          updateIncludesVisibility();
          updateMainForm(event.target.value, true);
        });
      });

      updateIncludesVisibility();

      const checkedRadio = container.querySelector('.package-selector__radio-input:checked');
      if (checkedRadio) {
        updateMainForm(checkedRadio.value, false);
      }

      container.dataset.bundleInitialized = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', initializeBundleSelectors);
  document.addEventListener('shopify:section:load', initializeBundleSelectors);
  document.addEventListener('app:product-page-loaded', initializeBundleSelectors);
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:block:select', initializeBundleSelectors);
  }
})();
